import React, { memo } from "react";
import api from "src/api";
import { useStore } from "src/store";
import { setDangerousHtml } from "src/utils";

const injectTabs = (tabs = [], query) => {
  let fn;

  fn = () => {
    fn.interval = setInterval(() => {
      const tabArea = document.querySelector(".gsc-tabsArea");

      if (tabArea) {
        const currentTabs = [...tabArea.querySelectorAll(".gsc-tabHeader")];

        for (let tab of tabs) {
          const { link, name, visible } = tab;

          if (name && visible && visible !== "false") {
            const el = document.createElement("a");
            el.setAttribute("class", "gsc-tabHeader gsc-tabhInactive gsc-inline-block");
            el.style.textDecoration = "none";
            link && el.setAttribute("href", link + query);

            el.innerText = name;

            const currentTab = currentTabs.find(t => t.innerText.toLowerCase() === name.toLowerCase());
            currentTab && tabArea.removeChild(currentTab);
            tabArea.appendChild(el);
          }
        }
        clearInterval(fn.interval);
      }
    }, 500);
  };

  return fn;
};

const cleanQueryParams = q => {
  const url = new URL(window.location.href);
  url.searchParams.delete("search_term");
  url.searchParams.set("q", q);
  window.history.replaceState(null, "", url);
};

const ResultsGCSE = memo(props => {
  const { results = {} } = props;
  const { googleCSEsearchEngineID, googleCSEParams = {}, menuItems = [] } = results;

  const store = useStore("config");
  const { brand, clientid: clientId, country: countryCode, visitorId, language, targetingScript, hotjarSyndicationScript } = store("config");

  const searchCallback = (_, searchTerm) => {
    api.searchCallback({ brand, clientId, countryCode, visitorId, language, provider: "gcse", searchTerm });
  };
  const TargetingScriptSnippet = memo(props => {
    const { targetingScript } = props;
    return <div ref={targetingScript ? setDangerousHtml(decodeURIComponent(targetingScript)) : {}} />;
  });
  const HotjarSyndicationScriptSnippet = memo(props => {
    const { hotjarSyndicationScript } = props;
    return <div ref={hotjarSyndicationScript ? setDangerousHtml(decodeURIComponent(hotjarSyndicationScript)) : {}} />;
  });

  cleanQueryParams(googleCSEParams.q);

  window.gcseInjectTabs && clearInterval(window.gcseInjectTabs.interval); // Clear previous interval
  window.gcseInjectTabs = injectTabs(menuItems, googleCSEParams.q);
  window.searchCallback = searchCallback;

  return (
    <div>
      <div
        ref={setDangerousHtml(`
        <script>
          (function() {
            window.__gcse || (window.__gcse = {});

            window.__gcse.callback = window.gcseInjectTabs;
            window.__gcse.searchCallbacks = { web: { starting: window.searchCallback }, image: { starting: window.searchCallback } };

            var cx = '${googleCSEsearchEngineID}';
            var gcse = document.createElement('script');
            gcse.type = 'text/javascript';
            gcse.async = true;
            gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(gcse, s);
          })();
        </script>
        <gcse:searchresults-only></gcse:searchresults-only>
      `)}
      />
      <TargetingScriptSnippet targetingScript={targetingScript} />
      <HotjarSyndicationScriptSnippet hotjarSyndicationScript={hotjarSyndicationScript} />
    </div>
  );
});

export default ResultsGCSE;
